/**
 * Convercus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomPropertyAttribute } from './custom-property-attribute';
import { PartnerType } from './partner-type';


export interface Partner { 
    /**
     * Array of custom properties
     */
    customProperties?: Array<CustomPropertyAttribute>;
    id?: string;
    logoUrl?: string;
    name?: string;
    networkPartnerId?: string;
    partnerType?: PartnerType;
    status?: Partner.StatusEnum;
}
export namespace Partner {
    export type StatusEnum = 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        ACTIVE: 'ACTIVE' as StatusEnum,
        INACTIVE: 'INACTIVE' as StatusEnum
    };
}


